export default __webpack_public_path__ + "static/media/transmissionLine.2741bf15.jpg";